import React, { useState } from "react";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import { arrow2, langIcon } from "../icon_assets";
import s from "./styles.module.css";
import "../commonStyle.css";
import BlurModal from "../CommonComponents/BlurModal/BlurModal";
import SelectLangContent from "./SelectLangContent";
import { isMobile } from "../helperFunc";

const ChnLangPref = (props) => {
  const { className } = props;
  const [show, setShow] = useState(false);

  const {
    leftIcon = langIcon,
    rightIcon = arrow2,
    text = (
      <HeadLines
        className={`
        ${
          isMobile ? `font-size12` : `font-size16 line-height19 letterSpacing05`
        } 
        ${s["textColorLang"]}`}
        text={"Change Language Preference"}
      />
    ),
  } = props;
  return (
    <>
      <Card
        onClick={() => setShow(true)}
        className={`
      bg-white
      margin-left16 
      margin-right16 
      boxRadius8
      ${s["card-shadow"]}
      ${s["border-card"]} 
      ${s["paddingY-11"]}
      ${s["paddingR21"]}
      ${s["paddingL13"]} 
      ${className}`}
      >
        <div className="d-flex justify-content-between">
          <div className={`d-flex`}>
            <div className={`${s["margin-right-13"]}`}>
              <img src={leftIcon} width={20} />
            </div>
            <div className="d-flex align-items-center">{text}</div>
          </div>
          <div className="">
            <img src={rightIcon} width={6} height={12} />
          </div>
        </div>
      </Card>
      <BlurModal
        show={show}
        onHide={() => setShow(false)}
        showDesktopHeader={!isMobile}
        desktopHeading="Select Language"
      >
        <SelectLangContent />
      </BlurModal>
    </>
  );
};

export default ChnLangPref;
